<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='科秘书管理' label2="新增科秘书" url="/person/sectionsecretary/list"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body">
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">姓名：</label>
            <div class="col-xl-3">
              <el-form-item prop="secretaryname" :rules="{required: true, message: '姓名不能为空', trigger: 'blur'}">
                <el-input v-model="form.secretaryname" placeholder="请输入姓名"></el-input>
              </el-form-item>
            </div>
            <label class="col-xl-2 col-form-label">工号：</label>
            <div class="col-xl-3">
              <el-form-item prop="secretaryno" :rules="{required: true, message: '工号不能为空', trigger: 'blur'}">
                <el-input v-model="form.secretaryno" placeholder="请输入工号"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">管理单元：</label>
            <div class="col-xl-3">
              <el-form-item prop="secretarysec" :rules="{required: true, message: '管理单元不能为空', trigger: 'blur'}">
                <el-select v-model="form.secretarysec" filterable placeholder="请选择">
                  <el-option label="请选择" value=""></el-option>
                  <el-option v-for="item in managesecOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <label class="col-xl-2 col-form-label">科秘书类型：</label>
            <div class="col-xl-3">
              <el-form-item prop="secretarytype" :rules="{required: true, message: '科秘书类型不能为空', trigger: 'blur'}">
                <el-select v-model="form.secretarytype" filterable placeholder="请选择">
                  <el-option label="请选择" value=""></el-option>
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">全科权限：</label>
            <div class="col-xl-3">
              <el-checkbox v-model="form.isqk" border>全科科秘书</el-checkbox>
            </div>
          </div>
          <div v-if="this.form.secretarytype=='1'" class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">管理单元范围：</label>
            <div class="col-xl-3">
              <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
            </div>
          </div>
          <div v-if="this.form.secretarytype=='1'" class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label"></label>
            <div class="col-xl-9">
              <el-tree v-loading="loading" :data="treedata" ref="tree" :filter-node-method="filterNode"
                default-expand-all show-checkbox node-key="id">
              </el-tree>
            </div>
          </div>
          <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
            <div class="m-form__actions m-form__actions--solid">
              <div class="row">
                <div class="col-lg-12 m--align-center">
                  <el-button type="success" icon="el-icon-s-order" @click="Save" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SectionSecretaryAdd',
    data() {
      return {
        form: {
          token: '',
          username: '',
          rolelevel: '',
          secretaryname: '',
          secretaryno: '',
          secretarysec: '',
          secretarytype: '',
          checkKeys: '',
          isqk: false
        },
        treedata: null,
        options: [{
          value: '1',
          label: '大科秘书'
        }, {
          value: '2',
          label: '科秘书'
        }],
        managesecOptions: [],
        fullscreenLoading: false,
        filterText: '',
        loading: true
      }
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    methods: {
      Save: function() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.fullscreenLoading = true
            if(this.form.secretarytype=='1'){
              this.form.checkKeys = this.$refs.tree.getCheckedKeys()
            }
            this.$http.post(this.$utils.Url.zpgl + '/api/APISecretary/Add', this.form)
              .then(res => {
                if (res.data.Code === 0) {
                  this.$message({
                    message: '保存成功',
                    type: 'success'
                  })
                  console.log('保存成功')
                  this.$router.push('/main/person/sectionsecretary/list')
                } else {
                  this.$message({
                    message: res.data.Msg + '，' + res.data.Error,
                    type: 'error'
                  })
                }
                this.fullscreenLoading = false
              })
              .catch(err => {
                console.log(err)
                this.$message({
                  message: '保存失败',
                  type: 'error'
                })
                this.fullscreenLoading = false
              })
          } else {
            console.log('error submit!!')
            return false;
          }
        })
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      LoadManageSec: function() {
        var args = {
          token: this.form.token,
          username: this.form.username,
          rolelevel: this.form.rolelevel
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
          that.managesecOptions = data.Data
        }, null, null, null)
      },
      LoadManageSecTree: function() {
        var args = {
          token: this.form.token
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionTree', args, function(data) {
          that.treedata = JSON.parse(data.Data)
          that.loading = false
        }, null, null, null)
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      this.form.username = sessionStorage.getItem('username')
      this.form.rolelevel = sessionStorage.getItem('rolelevel')
      this.LoadManageSec()
      this.LoadManageSecTree()
    }
  }
</script>

<style scoped="scoped">
  .el-form-item {
    margin-bottom: 0px;
  }

  .el-select {
    width: 100%;
  }
  
  /deep/.el-tree-node__label {
      font-size: 14px;
      margin-bottom: .5rem;
  }
</style>
